import { render, staticRenderFns } from "./SimplifyDistrictBoundaries.vue?vue&type=template&id=6831853d&scoped=true"
import script from "./SimplifyDistrictBoundaries.vue?vue&type=script&lang=js"
export * from "./SimplifyDistrictBoundaries.vue?vue&type=script&lang=js"
import style0 from "./SimplifyDistrictBoundaries.vue?vue&type=style&index=0&id=6831853d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6831853d",
  null
  
)

export default component.exports